const accountGroup = {
  getAccountGroups: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{
      accountGroups {
        AccountGroup_Id
        Name
      }}`
      })
      .then(r => r.data.accountGroups);
  },

  getGroupAccounts: async function() {
    var query = `{
        accountGroups {
          AccountGroup_Id
          Name
          Description
          Accounts {
            Account_Id,
            Billing_Name
            Billing_Address_Line_1
            Billing_Address_Line_2
            Billing_City
            Billing_State
            Billing_Zip
            Number_Of_Users
            Organizations {
              Organization_Id
              Parent_Organization_Id
              Organization_Type_Id
              Name
            }
            Users {
              User_Id
            }
          }
        }
      }`;
    return await this.$store.getters.fetcher({ query }).then(r => {
      return r.data.accountGroups;
    });
  },

  createAccountGroup: async function(accountGroupToCreate) {
    const query = `
    mutation($name: String!, $description: String!) {
      CreateAccountGroup(name: $name, description: $description) {
        AccountGroup_Id
      }
    }`;
    const variables = {
      name: accountGroupToCreate.Name,
      description: accountGroupToCreate.Description
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      accountGroupToCreate.AccountGroup_Id =
        r.data.CreateAccountGroup.AccountGroup_Id;
      return accountGroupToCreate;
    });
  },

  updateAccountGroup: async function(accountGroupToUpdate) {
    const query = `
    mutation($accountGroupId: Int! $name: String!, $description: String!) {
      UpdateAccountGroup(accountGroupId: $accountGroupId, name: $name, description: $description) {
        AccountGroup_Id
      }
    }`;
    const variables = {
      accountGroupId: parseInt(accountGroupToUpdate.AccountGroup_Id),
      name: accountGroupToUpdate.Name,
      description: accountGroupToUpdate.Description
    };
    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return accountGroupToUpdate;
    });
  }
};

export { accountGroup };
